/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import _ from "underscore";
import parse from "html-react-parser";
import { removeSelfClosingTags } from "./toolboxXmlHelpers";

// NOSONAR: `label` is Blockly's custom toolbox XML element (rendered via
// react-blockly-toolbox, then serialized to Blockly's toolbox XML), not a real
// HTML form label, so the `text` attribute is a valid Blockly toolbox attribute
// rather than an unknown prop. See the same pattern in Toolbox.js, Search/index.js,
// JSBlocks/index.js, and MyBlocks/index.js.
const MyBlockSearch = ({ libraries: libraryObj }) => {
    if (_.isEmpty(libraryObj)) { return null; }
    let libraries = [];

    function _getParsedBlocksFromLibrary (library) {
        return _.values(library.childComponents).map(block => {
            const {xml} = block.component;
            if (xml) {
                const parsedBlock = Blockly.Xml.textToDom(xml);
                let xmlText = "";

                if (parsedBlock.getElementsByTagName("variables").length > 0) {
                    let blockXml = parsedBlock.getElementsByTagName("variables")[0];
                    xmlText += Blockly.Xml.domToText(blockXml);
                }

                if (parsedBlock.getElementsByTagName("block").length > 0) {
                    let blockXml = parsedBlock.getElementsByTagName("block")[0];
                    blockXml.firstChild.setAttribute('code', block.code);
                    xmlText += Blockly.Xml.domToText(blockXml);
                }

                return xmlText
            }

            return null;
        });
    }

    _.keys(libraryObj).map((libraryKey) => {
        libraries.push({
            name: libraryKey,
            parsedBlocks: _getParsedBlocksFromLibrary(libraryObj[libraryKey])
        })
    });

    return libraries.map(library => {
        return (
            <>
                <label text={library.name} /> {/* NOSONAR */}
                {library.parsedBlocks.map(block => parse(removeSelfClosingTags(block)))}
            </>
        )
    })
};

MyBlockSearch.propTypes = {
    libraries: PropTypes.object
};

export default MyBlockSearch;